import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import * as yup from "yup"

import {
    Button,
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import TextArea from "@/shared/input/TextArea"
import TextInput from "@/shared/input/TextInput"
import Modal from "@/shared/modal"

import { OldBelief } from "../model/types/old-belief"

import "./styles.scss"

type Props = {
    isOpen: boolean
    oldBeliefIndex: number
    oldBeliefs: any
    onClose: () => void
    onSubmit: (values?: Pick<OldBelief, "title" | "description">, index?: number) => void
}

export const OldBeliefGoalModal = ({ isOpen, oldBeliefIndex, oldBeliefs, onClose, onSubmit }: Props) => {
    const { t } = useTranslation()

    const values = oldBeliefs[oldBeliefIndex]

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        shouldUnregister: true,
        defaultValues: values,
        resolver: yupResolver(
            yup.object({
                title: yup.string().required(t("Field is required"))
            })
        )
    })

    const onSubmitOldBelief = values => {
        onSubmit(values)
    }

    return (
        <Modal
            onClose={onClose}
            show={isOpen}
            modalBodyAriaLabel={t("Add / Edit Old Belief")}
            headerContent={
                <Typography
                    text={t("Add / Edit Old Belief")}
                    className="p-3 m-0"
                    color={ETypographyColor.Black}
                    weight={ETypographyWeight.Medium}
                    family={ETypographyFamily.DmSerif}
                    alignment={ETypographyAlignment.Center}
                    size={ETypographySize.Heading2}
                    tag={ETypographyTag.Heading2}
                />
            }
            modalBodyClass="old-belief-modal"
        >
            <div className="old-belief-modal__body">
                <p className="mb-[20px] text-gray-100">
                    {t(
                        "What’s one old belief that has been holding you back? What is the significance of this old belief in your past & present stages of life?"
                    )}
                </p>
                <form onSubmit={handleSubmit(onSubmitOldBelief)}>
                    <TextInput
                        groupClassName="mb-[10px] w-100 gray-placeholder"
                        variant="rect"
                        maxLength={60}
                        customPlaceholder={
                            <>
                                <span className="text-gray-200 font-extrabold">{t("Title")}</span>{" "}
                                <span className="text-gray-200">
                                    ({t("required, {{number}} character max", { number: 60 })})
                                </span>
                            </>
                        }
                        register={register}
                        name="title"
                        errors={errors}
                    />

                    <TextArea
                        variant="rect"
                        className="mb-[40px] w-100 gray-placeholder text-gray-100"
                        rows={3}
                        placeholder={t("Description of Significance (optional)")}
                        register={register}
                        name="description"
                        errors={errors}
                    />

                    <div className="w-min mx-auto mt-[40px]">
                        <Button>{t("Done")}</Button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}
